export enum PeopleTabs {
  Absences = 'PEOP_ABSENCES',
  Basic = 'PEOP_BASIC',
  Contact = 'PEOP_CONTACT',
  CustomData = 'PEOP_CUSTOM_DATA',
  DecisionRegistry = 'PEOP_DECISION_REGISTRY',
  Development = 'PEOP_DEVELOPMENT',
  Documents = 'PEOP_DOCUMENTS',
  Equipment = 'PEOP_EQUIPMENT',
  JobDescription = 'PEOP_JOB_DESCRIPTION',
  Performance = 'PEOP_PERFORMANCE',
  Collaboration = 'PEOP_COLLABORATION',
}

export enum DevelopmentTabs {
  Competencies = 'DEV_COMPETENCIES',
  Education = 'DEV_EDUCATION',
  Experience = 'DEV_EXPERIENCE',
  JobReqEvaluation = 'DEV_JOB_REQUIREMENT_EVAL',
  DevelopmentPlan = 'DEV_PLAN',
}

export enum RewardingTabs {
  Acknowledgements = 'REW_ACKNOWLEDGEMENTS',
  BankAccount = 'REW_BANK_ACCOUNT',
  Benefits = 'REW_BENEFITS',
  BillableHours = 'REW_BILLABLE_HOURS',
  CustomData = 'REW_CUSTOM_DATA',
  Documents = 'REW_DOCUMENTS',
  General = 'REW_GENERAL',
  Incentives = 'REW_INCENTIVES',
  Summary = 'REW_SUMMARY',
  WorkTime = 'REW_TIME_REPORTING',
}

export enum PerformanceTabs {
  AppraisalEvaluation = 'PERF_APPRAISAL',
  Feedback = 'PERF_FEEDBACK',
  GoalEvaluation = 'PERF_GOAL_EVALUATION',
  GoalSetting = 'PERF_GOAL_SETTING_REVIEW',
  Notes = 'PERF_NOTES',
  PerformanceEvaluation = 'PERF_PERF_EVAL',
  ProcessTemplates = 'PERF_PROCESS_TEMPLATES',
  SelfEvaluation = 'PERF_SELF_EVAL',
  StatusDiscussion = 'PERF_STATUS_DISC',
}
